import React, { useState, useEffect } from 'react';
import DropdownWithIcon from './DropdownWithIcon';
import { CategorySetting } from './CategorySetting';
import { dashboardColors, theme } from '../../../themes/Theme';
import customToast from '../../../components/common/basic/Toast';

const CategoryDropdown = ({
    value = null,
    onChange = () => { },
    onBlur = () => { },
    categories = [],
    onCreateNewCategory= () => { },
    disabled = false,
    className = "",
    error = null,
    touched = false,
    loading = false
}) => {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [isCreating, setIsCreating] = useState(false);

    const buildOptions = () => {
        const categoryOptions = categories?.map(cat => ({
            value: cat?.category_id,
            label: cat?.category_name,
            data: cat
        }));

        const createNewOption = {
            value: 'create_new',
            label: 'Create New Category',
            isCreateOption: true
        };

        return [...categoryOptions, createNewOption];
    };

    const options = buildOptions();

    const handleDropdownChange = (option) => {
        if (option && option?.isCreateOption) {
            setShowCreateModal(true);
        } else {
            onChange(option);
        }
    };

    const handleCreateCategory = async (values) => {
        setIsCreating(true);
        try {
            const newCategory = await onCreateNewCategory(values);
            
            // Auto-select the newly created category
            const newOption = {
                value: newCategory?.category_id,
                label: newCategory?.category_name,
                data: newCategory
            };
            
            onChange(newOption);
            setShowCreateModal(false);
        } catch (error) {
            customToast.error(error?.response?.data?.message || "Something went wrong")
        } finally {
            setIsCreating(false);
        }
    };

    const getOptionLabel = (option) => {
        if (option?.isCreateOption) {
            return (
                <div className="d-flex align-items-center create-category-option">
                    <span>{option?.label}</span>
                </div>
            );
        }
        return option?.label;
    };

    return (
        <>
            <DropdownWithIcon
                value={value}
                options={options}
                onChange={handleDropdownChange}
                onBlur={onBlur}
                getOptionLabel={getOptionLabel}
                disabled={disabled || loading}
                className={className}
                placeholder="Select category"
                isSearchable={true}
                menuPlacement="auto"
            />
            
            {error && touched && (
                <p className="text-danger mt-2">{error}</p>
            )}

            <CategorySetting
                isOpen={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                mode="add"
                initialData={null}
                onSubmit={handleCreateCategory}
                loading={isCreating}
            />

            <style>{
                `
                .create-category-option{
                    color: ${dashboardColors[theme].primary};
                }
                
                `

            }</style>
        </>
    );
};

export default CategoryDropdown;
